import { createContext } from 'lib/createContext'
import React, { PropsWithChildren, useState } from 'react'
import { RevokeTarget } from 'api/admin/userPermissions/types'

type Workflow = {
  open: () => void
  close: () => void
  isOpen: boolean
}

type RevokeWorkflow = {
  open: (target: RevokeTarget) => void
  close: () => void
  isOpen: boolean
  target: RevokeTarget | null
}

export type UserPermissionsWorkflowsContextState = {
  createUserPermissionsFlow: Workflow
  authorizeAdminFlow: Workflow
  removeUserPermissionsFlow: RevokeWorkflow
}

const [
  UserPermissionsWorkflowsContext,
  useUserPermissionsWorkflowsContextValue,
] = createContext<UserPermissionsWorkflowsContextState>({
  name: 'UserPermissionsWorkflowsContext',
})

export const UserPermissionsWorkflowsProvider = ({
  children,
}: PropsWithChildren) => {
  const [isCreateOpen, setIsCreateOpen] = useState(false)
  const [isAuthorizeAdminOpen, setIsAuthorizeAdminOpen] = useState(false)
  const [isRemoveOpen, setIsRemoveOpen] = useState(false)
  const [removeTarget, setRemoveTarget] = useState<RevokeTarget | null>(null)

  const value: UserPermissionsWorkflowsContextState = {
    createUserPermissionsFlow: {
      open: () => setIsCreateOpen(true),
      close: () => setIsCreateOpen(false),
      isOpen: isCreateOpen,
    },
    authorizeAdminFlow: {
      open: () => setIsAuthorizeAdminOpen(true),
      close: () => setIsAuthorizeAdminOpen(false),
      isOpen: isAuthorizeAdminOpen,
    },
    removeUserPermissionsFlow: {
      open: (target) => {
        setRemoveTarget(target)
        setIsRemoveOpen(true)
      },
      close: () => {
        setIsRemoveOpen(false)
        setRemoveTarget(null)
      },
      isOpen: isRemoveOpen,
      target: removeTarget,
    },
  }

  return (
    <UserPermissionsWorkflowsContext.Provider value={value}>
      {children}
    </UserPermissionsWorkflowsContext.Provider>
  )
}

export { useUserPermissionsWorkflowsContextValue }
